export default {
  actions: {
    async pingFast({dispatch}) {
      return await dispatch('apiQuery', {method: '/ping'})
    },
    async pingDirty({dispatch}, body) {
      return await dispatch('apiQuery', {method: '/ping', body})
    }
  }
}